import { render, staticRenderFns } from "./MainBookCompCard1.vue?vue&type=template&id=29e99dc7"
import script from "./MainBookCompCard1.vue?vue&type=script&lang=js"
export * from "./MainBookCompCard1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports